import i18n from '@/main';
import CarUtils from '@/utils/CarUtils';
import { reactive, computed } from 'vue';
import validators from '@/utils/validators';
import messageBox from 'element-ui/lib/message-box';
import notification from 'element-ui/lib/notification';
import { paginarArray, ordenarArray } from '../mixins';

const state = reactive({
    dados: [],
    itensSelecionados: [],
    paginaDados: 1,
    ordemDados: '',
    itensPorPagina: 10,
    resultado: null,
    quantidadeResultados: 0
});

function clear() {
    state.inputData = '';
    state.dados = [];
    state.itensSelecionados = [];
    state.paginaDados = 1;
    state.ordemDados = '';
    state.resultado = null;
    state.quantidadeResultados = 0;
}

const translate = (key, isCommun = false) =>
    isCommun
        ? i18n.t(`mensagens.comuns.${key}`)
        : i18n.t(`denuncia.view.labels.inserir_denucia.${key}`);

const notifyError = messageKey => notification.error(translate(messageKey));
const notifySuccess = messageKey => notification.success(translate(messageKey));

const listaDados = computed(() => {
    const dados = ordenarArray(state.dados, 'label', state.ordemDados);
    const lista = paginarArray(dados, state.itensPorPagina);

    return {
        data: lista[state.paginaDados - 1] || [],
        totalItens: state.dados.length,
        totalPaginas: lista.length
    };
});

function handleSelectionChange(value) {
    state.itensSelecionados = value;
}

function handleSortChangeData({ order }) {
    state.ordemDados = order;
}

function mudarPaginaDados(paginaDados) {
    state.paginaDados = paginaDados;
}

function adicionarItem(value) {
    let dados = state.dados;
    const isCpfValid = validators.validarCpf(value);
    const isCnpjValid = validators.validarCnpj(value);
    const isCarValid = CarUtils.isCar(value);
    const alreadyExists = dados.some(item => item.value === value);

    if (!value) {
        return notifyError('field_vazio');
    }
    if (alreadyExists) {
        return notifyError('dado_existente');
    }

    if (isNaN(value[0])) {
        if (isCarValid) {
            dados.push({
                value: value,
                label: value,
                tipo: 'CAR'
            });
            state.dados = dados;

            return notifySuccess('car_adicionado');
        } else {
            return notifyError('car_invalido');
        }
    } else {
        if (isCpfValid) {
            dados.push({
                value: value,
                label: value,
                tipo: 'CPF'
            });
            state.dados = dados;

            return notifySuccess('cpf_adicionado');
        } else if (isCnpjValid) {
            dados.push({
                value: value,
                label: value,
                tipo: 'CNPJ'
            });
            state.dados = dados;

            return notifySuccess('cnpj_adicionado');
        } else {
            return notifyError('cpf_cnpj_invalido');
        }
    }
}

function removerItem() {
    state.dados = state.dados.filter(
        item => !state.itensSelecionados.includes(item)
    );
    state.itensSelecionados = [];
    if (listaDados.data.length === 0) {
        state.paginaDados = state.paginaDados === 1 ? 1 : state.paginaDados - 1;
    }
}

function confirmarRemocao() {
    if (state.itensSelecionados.length === 0) {
        return notifyError('selecione_item');
    }
    const confirmButtonText = translate('sim', true);
    const cancelButtonText = translate('cancelar', true);
    const aviso = translate('aviso', true);
    const mensagemRemocao =
        state.itensSelecionados.length > 1
            ? translate('mensagem_remocao_plural')
            : translate('mensagem_remocao_singular');
    const params = {
        confirmButtonText,
        confirmButtonClass: 'denuncia-inserir__button-box',
        cancelButtonText,
        type: 'warning'
    };

    return messageBox.confirm(mensagemRemocao, aviso, params).then(result => {
        if (result === 'confirm') {
            const mensagemKey =
                state.itensSelecionados.length > 1
                    ? 'itens_removidos'
                    : 'item_removido';

            removerItem();
            state.notifySuccess(mensagemKey);
        }
    });
}

const useShareReport = () => {
    return {
        state,
        listaDados,
        clear,
        handleSortChangeData,
        adicionarItem,
        confirmarRemocao,
        removerItem,
        notifyError,
        notifySuccess,
        mudarPaginaDados,
        handleSelectionChange,
        translate
    };
};

export default useShareReport;
